import 'Plugins/ajaxFilteringPlugin';

export default function initAjaxFiltering() {
	jQuery('.js-filtering-section').ajaxFiltering({
		container: '.js-items-container',
		items: '.col',
		filterLists: '[data-category]',
		filterLinks: '[data-filter]',
		activeClass: 'active',
		loadClass: 'loading',
		infiniteScroll: false
	});
}